import React from 'react';
import { useHistory } from 'react-router';
import { useQuery } from '@apollo/client';

// graphql
import { GET_ALL_JOBS_IN_DATE_RANGE_FOREMAN } from '../../../../../graphql/job/job.queries';

// components
import FourSectionCardListItem from '../../../../../components/collections/FourSectionCardListItem/FourSectionCardListItem.component';

// mui
import { Typography, Container, Grid } from '@mui/material';

// shared
import { filterDataObjectListBySearch } from '../../../../../shared/filtering/search';
import moment from 'moment';

export default function JobsInDateRange({ startDate, endDate, label, filterOptions }) {

    const history = useHistory()

    const { data } = useQuery(GET_ALL_JOBS_IN_DATE_RANGE_FOREMAN, {
        variables: { startDate, endDate }
    })

    let jobs = []

    if(data && data.jobsInDateRangeForForeman) {
        jobs = [...filterDataObjectListBySearch(data.jobsInDateRangeForForeman, filterOptions.searchValue, filterOptions.searchBy)]
    }

    return (<Container maxWidth disableGutters sx={{ marginBottom: 8 }}>
        <Grid container spacing={2}>
            <Grid item xs={4}><Typography variant="h5">{label}</Typography></Grid>
            <Grid item container direction='column' xs={8}>
                {
                    jobs.map((job, index) => {
                        return (<Grid item key={`${job.name} - ${index}`}><FourSectionCardListItem 
                            {...job}
                            mainTitle={job.name}
                            subTitle={`Est. Start Date: ${job.estimatedStartDate ? moment(job.estimatedStartDate).format("MM/DD/YYYY") : null}`}
                            leftData={[`${job.street1 ? job.street1 : ''}`, `${job.city ? job.city : ''}${job.state ? ',' : ''} ${job.state ? job.state : ''} ${job.zipcode ? job.zipcode : ''}`]}
                            rightData={null}
                            onClick={() => history.push(`/jobs/details/${job.id}`)}
                            /></Grid>)
                    })
                }
            </Grid>
        </Grid>
    </Container>)
}